var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-mobile-full-screen-container", [
    _c(
      "div",
      { staticClass: "w100" },
      [
        _c(
          "w-breadcrumb",
          { attrs: { crumbs: _vm.path } },
          [
            _c("w-spacer"),
            _vm.$wf.isMdUp
              ? _c(
                  "w-button",
                  {
                    attrs: {
                      icon: "save",
                      disabled: _vm.saving || !_vm.hasModule,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.save()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "w-scroll-view",
          { attrs: { tag: "w-container" } },
          [
            _c(
              "w-row",
              [
                _c(
                  "w-col",
                  { attrs: { xs: "12", md: "6" } },
                  [
                    _vm.hasModule
                      ? _c(
                          "w-card",
                          [
                            _c("w-card-title", [
                              _vm._v(_vm._s(_vm.$ct("title"))),
                            ]),
                            _c(
                              "w-card-content",
                              [
                                _c(
                                  "w-row",
                                  [
                                    _c(
                                      "w-col",
                                      { attrs: { xs: "12" } },
                                      [
                                        _c("w-input", {
                                          attrs: {
                                            label: _vm.$ct("public-key"),
                                            fancy: "",
                                          },
                                          model: {
                                            value: _vm.settings.PublicKey,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.settings,
                                                "PublicKey",
                                                $$v
                                              )
                                            },
                                            expression: "settings.PublicKey",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "w-col",
                                      { attrs: { xs: "12" } },
                                      [
                                        _c("w-input", {
                                          attrs: {
                                            label: _vm.$ct("private-key"),
                                            fancy: "",
                                          },
                                          model: {
                                            value: _vm.settings.PrivateKey,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.settings,
                                                "PrivateKey",
                                                $$v
                                              )
                                            },
                                            expression: "settings.PrivateKey",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c("app-missing-module", {
                          attrs: { "module-id": _vm.mod },
                        }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }